// 环境配置
const orgen = [
  {
    path: '/orgen/entry', // 基础环境
    component: () => import(/* webpackChunkName: "orgenEntry" */ '@/views/orgen/entry'),
    meta: {
      title: '机构账户',
    },
  },
  {
    path: '/orgen/edit/:id', // 查看/编辑
    component: () => import(/* webpackChunkName: "orgenEdit" */ '@/views/orgen/edit'),
    meta: {
      title: '编辑',
    },
  },
  {
    path: '/orgen/view/:id', // 配置文件
    component: () => import(/* webpackChunkName: "orgenView" */ '@/views/orgen/view'),
    meta: {
      title: '查看',
    },
  },
];

export default orgen;
